import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

export type ResetPasswordResponse = components["schemas"]["ResetPasswordResponse"];

export function useResetPassword() {
  return useMutation({
    mutationFn: async (id: string) => {
      const { data, error } = await apiClient.POST("/v1/admin/users/{id}/reset-password", {
        params: { path: { id } },
      });
      if (error) throw error;
      return data as ResetPasswordResponse;
    },
  });
}
